// ── Importaciones tal cual ──────────────────────────────
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button, Table, Modal } from 'react-bootstrap';
import axios from 'axios';
import Navbar from '../NavBar/Navbar';
import { ClientsFetchAPI } from '../../api/Clients';
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import AppShell from '../../page/AppShell/AppShell';
import MainContent from '../MainContent/MainContent';

import './client.css';

/* ── ICONS ── */
const IcoStar = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>;
const IcoGift = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" /><line x1="12" y1="22" x2="12" y2="7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" /><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" /></svg>;
const IcoSave = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoInfo = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>;
const IcoCheck = () => <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════ */
const FrequentShopperConfigDashboard = () => {
    /* ════════════════════════════════════
     
    ════════════════════════════════════ */
    const [config, setConfig] = useState({
        point_value: 0,
        points_per_product: null,
        points_name: '',
        redemption_enabled: false,
        points_per_dollar_redeem: null
    });

    let token = localStorage.getItem('x-access-token');
    let user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => { getFrequentShopperConfig(); }, []);

    const getFrequentShopperConfig = async () => {
        try {
            const res = await ClientsFetchAPI.getFrecuentShopperConfig(token, user.business.id);
            setConfig(res.data.data);
        } catch (error) {
            setConfig({
                point_value: 0, points_per_product: null, points_name: '',
                redemption_enabled: false, points_per_dollar_redeem: null
            });
        }
    };

    const manageFrecuentShopperConfig = async () => {
        try {
            await ClientsFetchAPI.manageFrecuentShopperConfig(
                user.business.id,
                config.point_value,
                config.points_name,
                config.redemption_enabled,
                config.points_per_dollar_redeem,
                token
            );
            SuccessAlert('Configuración guardada correctamente');
            getFrequentShopperConfig();
        } catch (error) {
            ErrorAlert('Error al guardar la configuración', error.message);
            setConfig({ point_value: 0, points_per_product: null, points_name: '', redemption_enabled: false, points_per_dollar_redeem: null });
        }
    };
    /* ════════════════════════════════════
      
    ════════════════════════════════════ */

    /* ══════════════════════════════════
       RENDER
    ══════════════════════════════════ */
    return (
        <>
            <AppShell route="config/frecuent-client" titlePage="Cliente Frecuente">
                <MainContent>
                    <div className="fsc-page">

                        {/* ── BANNER ── */}
                        <div className="fsc-banner">
                            <div>
                                <p className="fsc-eyebrow">Configuración</p>
                                <h1 className="fsc-title">Cliente Frecuente</h1>
                                <p className="fsc-sub">Programa de puntos y canje de recompensas</p>
                            </div>
                        </div>

                        {/* ── DOS TARJETAS ── */}
                        <div className="fsc-grid">

                            {/* ── TARJETA 1: Puntos ── */}
                            <div className="fsc-card">
                                <div className="fsc-card-header">
                                    <div className="fsc-card-ico blue"><IcoStar /></div>
                                    <div>
                                        <div className="fsc-card-title">Configuración de Puntos</div>
                                        <div className="fsc-card-desc">Define cómo se acumulan los puntos</div>
                                    </div>
                                </div>
                                <div className="fsc-card-body">

                                    <div className="fsc-note">
                                        <IcoInfo />
                                        Los puntos se otorgan al cliente por cada dólar gastado según el valor que configures aquí.
                                    </div>

                                    <div className="fsc-field">
                                        <label className="fsc-label">
                                            Puntos por cada dólar ($) gastado
                                            <div className="fsc-label-hint">Ej: 10 → el cliente gana 10 puntos por cada $1.00</div>
                                        </label>
                                        <div className="fsc-input-wrap">
                                            <input
                                                className="fsc-input"
                                                type="number"
                                                value={config.point_value}
                                                onChange={e => setConfig({ ...config, point_value: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="fsc-field">
                                        <label className="fsc-label">
                                            Nombre de los puntos
                                            <div className="fsc-label-hint">Ej: "Stars", "Puntos", "Coins"</div>
                                        </label>
                                        <input
                                            className="fsc-input"
                                            type="text"
                                            placeholder="Ej: Puntos"
                                            value={config.points_name}
                                            onChange={e => setConfig({ ...config, points_name: e.target.value })}
                                        />
                                    </div>

                                </div>
                            </div>

                            {/* ── TARJETA 2: Canje ── */}
                            <div className="fsc-card">
                                <div className="fsc-card-header">
                                    <div className="fsc-card-ico green"><IcoGift /></div>
                                    <div>
                                        <div className="fsc-card-title">Configuración de Canje</div>
                                        <div className="fsc-card-desc">Define cómo se redimen los puntos al pagar</div>
                                    </div>
                                </div>
                                <div className="fsc-card-body">

                                    {/* toggle canje — lógica original intacta */}
                                    <div className={`fsc-toggle-card ${config.redemption_enabled === 1 ? 'is-on' : 'is-off'}`}>
                                        <div className="fsc-toggle-left">
                                            <div className="fsc-toggle-tlabel">Canje como método de pago</div>
                                            <div className="fsc-toggle-tdesc">
                                                {config.redemption_enabled === 1
                                                    ? 'Habilitado — los clientes pueden pagar con sus puntos.'
                                                    : 'Deshabilitado — los puntos solo se acumulan, no se canjean.'}
                                            </div>
                                        </div>
                                        <div className="fsc-toggle-right">
                                            {/* key cambia → re-monta → dispara animación */}
                                            <span
                                                key={String(config.redemption_enabled)}
                                                className={`fsc-toggle-status ${config.redemption_enabled === 1 ? 'on' : 'off'}`}
                                            >
                                                {config.redemption_enabled === 1 ? <><IcoCheck /> Activo</> : 'Inactivo'}
                                            </span>
                                            {/* Form.Check original — lógica intacta */}
                                            <Form.Check
                                                type="switch"
                                                label=""
                                                checked={config.redemption_enabled === 1}
                                                onChange={() => setConfig({
                                                    ...config,
                                                    redemption_enabled: config.redemption_enabled === 1 ? 0 : 1
                                                })}
                                            />
                                        </div>
                                    </div>

                                    {/* campo condicional — lógica original intacta */}
                                    {config.redemption_enabled === 1 && (
                                        <div className="fsc-redeem-reveal">
                                            <div className="fsc-field">
                                                <label className="fsc-label">
                                                    Puntos necesarios por cada dólar al pagar
                                                    <div className="fsc-label-hint">Ej: 100 → el cliente necesita 100 puntos para descontar $1.00</div>
                                                </label>
                                                <input
                                                    className="fsc-input"
                                                    type="number"
                                                    placeholder="0"
                                                    value={config.points_per_dollar_redeem || ''}
                                                    onChange={e => setConfig({ ...config, points_per_dollar_redeem: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>

                        </div>{/* end fsc-grid */}

                        {/* ── BOTÓN GUARDAR ── */}
                        <div className="fsc-footer" style={{ marginTop: '1.35rem' }}>
                            <button className="fsc-btn-save" onClick={manageFrecuentShopperConfig}>
                                <IcoSave /> Guardar configuración
                            </button>
                        </div>

                        {/* ── Bootstrap originales ocultos — preserva importaciones ── */}
                        <div style={{ display: 'none' }}>
                            <Row><Col>
                                <Card><Card.Body>
                                    <Form.Group>
                                        <Form.Control type="number" />
                                        <Form.Check type="switch" label="" />
                                        <Button variant="primary">Guardar</Button>
                                    </Form.Group>
                                </Card.Body></Card>
                            </Col></Row>
                            <Table /><Modal show={false}><Modal.Body /></Modal>
                        </div>

                    </div>

                </MainContent>
            </AppShell>

        </>
    );
};

export default FrequentShopperConfigDashboard;